export const Ranker = 'tight-tree';
export const SubGraphSpacing = 100;
export const DirectionUp = 'up';
export const DirectionDown = 'down';
export const DirectionLeft = 'left';
export const DirectionRight = 'right';
export const Directions = {
    [DirectionUp]: 'BT',
    [DirectionDown]: 'TB',
    [DirectionLeft]: 'RL',
    [DirectionRight]: 'LR'
};
export const PackingBin = 'bin';
export const PackingStack = 'stack';
export const Packings = [PackingBin, PackingStack];
export const PhysTextureSize = 256;
export const SpringTextureSize = 4096;
export const MaxIndexBuffer = 65536;
export const MinRelLength = 100;
export const Gravity = 100;
export const SimulationStopVelocity = 100;
export const MappingEnd = 999999;
export const ActiveAnimDuration = 1000;
export const DefaultNodeSize = 25;
export const DefaultRelWidth = 1;
export const DisabledRelColor = '#ededed';
// Factor to make nodes same size in WebGL renderer and Canvas
export const GlAdjust = 1 / 0.38;
